import { ConnectionStrategy } from '../strategy';
export function getAnchor(pos, terminalView, terminalMagnet) {
    const end = ConnectionStrategy.presets.pinRelative.call(this.paper, {}, terminalView, terminalMagnet, pos, this.model);
    return end.anchor;
}
export function getViewBBox(view, quick) {
    if (quick) {
        return view.cell.getBBox();
    }
    return view.cell.isEdge()
        ? view.getConnection().bbox()
        : view.getNodeUnrotatedBBox(view.container);
}
//# sourceMappingURL=util.js.map